module.exports = __webpack_public_path__ + "img/Monte_Kope_sauna_1.6e10452b.jpg";